import { ClienteProdutoIdentificacao } from '../../../../../../../types/cliente-produto';
import { CollapsibleSection } from './collapsible-section';
import { Row } from './styles';

interface Props {
  data: ClienteProdutoIdentificacao;
}

export const IdentificacaoSection = ({ data }: Props) => (
  <CollapsibleSection
    title="Identificação"
    defaultOpen
    testId="produto-section-identificacao"
  >
    <Row>
      <span>Nome</span>
      <span>{data.nome || '—'}</span>
    </Row>
    {data.categoriaDescricao && (
      <Row>
        <span>Categoria</span>
        <span>{data.categoriaDescricao}</span>
      </Row>
    )}
    {data.idiomaDescricao && (
      <Row>
        <span>Idioma</span>
        <span>{data.idiomaDescricao}</span>
      </Row>
    )}
    {data.sku && (
      <Row>
        <span>SKU</span>
        <span>{data.sku}</span>
      </Row>
    )}
    {data.codigoTb3 && (
      <Row>
        <span>Código TB3</span>
        <span>{data.codigoTb3}</span>
      </Row>
    )}
    {data.cademiProdutoId && (
      <Row>
        <span>ID Cademi</span>
        <span>{data.cademiProdutoId}</span>
      </Row>
    )}
    {data.astromembersProdutoId && (
      <Row>
        <span>ID Astromembers</span>
        <span>{data.astromembersProdutoId}</span>
      </Row>
    )}
    {data.imagemProduto && (
      <Row>
        <span>Imagem</span>
        <span>
          <a
            href={data.imagemProduto}
            target="_blank"
            rel="noreferrer noopener"
          >
            Abrir
          </a>
        </span>
      </Row>
    )}
    {data.descricao && (
      <Row>
        <span>Descrição</span>
        <span dangerouslySetInnerHTML={{ __html: data.descricao }} />
      </Row>
    )}
  </CollapsibleSection>
);
